module.exports = __webpack_public_path__ + "img/m-mingxibaobiao.a1c069a4.svg";